import type { MatterDraft } from "../app/ui-types.js";
import { getJurisdictionPack } from "./jurisdiction-packs.js";

const proceedingKey = {
  "Deposition / Examination": "deposition-examination",
  "Investigation / Interview": "investigation-interview",
  Conference: "conference",
  Hearing: "hearing"
} as const;

export const recordingAuthorityStatus = (matter: MatterDraft) => {
  const rules =
    getJurisdictionPack(matter.jurisdictionPack).authorityByProceeding[
      proceedingKey[matter.proceeding]
    ];
  const metadataComplete =
    matter.title.trim().length > 0 &&
    matter.reference.trim().length > 0 &&
    matter.venue.trim().length > 0 &&
    matter.date.trim().length > 0 &&
    matter.timezone.trim().length > 0 &&
    matter.languages.length > 0 &&
    matter.participants.length > 0;
  const canRecord =
    matter.authority.userAttestation &&
    matter.authority.participantNotice &&
    (!rules.participantConsent || matter.authority.participantConsent) &&
    matter.authority.confidentialityReviewed &&
    (!rules.courtApproval || matter.authority.courtApproval);
  return {
    canRecord,
    matterReady: metadataComplete,
    metadataComplete,
    requiresCourtApproval: rules.courtApproval,
    requiresParticipantConsent: rules.participantConsent
  };
};
